import { apiClient, Auth } from '@/shared/api'

import { TRefundChecklist } from '../model/schema'

export const getRefundChecklist = async (contractId: number) => {
  const { data } = await apiClient.get<TRefundChecklist>({
    endpoint: `/guest/contracts/${contractId}/refund/checklist`,
    auth: Auth.REQUIRED,
  })

  return data
}
